import { render, staticRenderFns } from "./OrderNotice.vue?vue&type=template&id=28774de3&"
import script from "./OrderNotice.vue?vue&type=script&lang=ts&"
export * from "./OrderNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports